/**
 * ProjectMilestoneService
 * Service for ProjectMilestone entity operations
 * Route: api/project-milestones
 * Controller: ProjectMilestoneController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectMilestoneService
 * Handles project milestone CRUD operations
 * Maps to /api/project-milestones endpoint
 */
export class ProjectMilestoneService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectMilestoneService.DEFAULT_SERVICE_PATH,
            basePath: ProjectMilestoneService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectMilestoneService.DEFAULT_SERVICE_PATH = 'projects';
ProjectMilestoneService.BASE_PATH = 'api/project-milestones';
//# sourceMappingURL=ProjectMilestoneService.js.map